<template>
  <div>
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
    >
      <v-flex xs12>
        <v-card
          id="visitorLogDetails"
          class="max-shadow"
        >
          <v-toolbar
            :class="{ 'elevation-2': scrolled}"
            color="white"
            flat
            height="64"
          >
            <v-btn
              icon
              @click="navigateBack"
            >
              <v-icon color="iconColor">
                arrow_back
              </v-icon>
            </v-btn>
            <v-toolbar-title>
              Visitor Log Details
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <template v-if="profile.role !== 'admin'">
                <v-btn
                  flat
                  large
                  color="primary"
                  @click="saveVisitor"
                >
                  Save
                </v-btn>
              </template>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout
            row
            wrap
          >
            <v-flex xs3>
              <v-layout
                column
                justify-space-around
                align-center

                class="pa-4 ml-3"
              >
                <avatar
                  :size="160"
                  :src="visitorLogItem.photoUri"
                  :text="visitorLogItem.name"
                />
                <v-img
                  v-if="visitorLogItem.idUri"
                  class="mt-5"
                  :src="visitorLogItem.idUri"
                  width="160"
                  height="160"
                  style="border-radius: 9px"
                />
              </v-layout>
            </v-flex>
            <v-layout
              v-scroll:#visitorLogDetailsForm="onScroll"
              column
            >
              <v-flex
                xs12
                class="px-4 pb-4 pt-2"
              >
                <v-form
                  id="visitorLogDetailsForm"
                  ref="form"
                  class="form"
                >
                  <v-text-field
                    id="full_name"
                    :value="visitorLogItem.name"
                    name="visitorName"
                    label="Visitor Name"
                    :disabled="profile.role === 'admin'"
                    required
                  />
                  <phone-field
                    id="phone"
                    v-model="visitorLogItem.phone"
                    default-country-code="IN"
                    disabled
                  />
                  <v-text-field
                    id="email"
                    :value="visitorLogItem.email"
                    name="visitorEmail"
                    label="Visitor Email"
                    :disabled="profile.role === 'admin'"
                    required
                  />
                  <v-text-field
                    id="company"
                    :value="visitorLogItem.company"
                    name="company"
                    label="Company"
                    :disabled="profile.role === 'admin'"
                    required
                  />
                  <v-text-field
                    id="purpose"
                    :value="visitorLogItem.visitorType"
                    name="purpose"
                    label="Purpose"
                    disabled
                  />
                  <v-text-field
                    :value="toDate(visitorLogItem.checkInDate)"
                    name="checkInDate"
                    label="checkin Date"
                    disabled
                  />
                  <template v-if="visitorLogItem.hostUid">
                    <v-text-field
                      :value="visitorLogItem.hostName"
                      name="host"
                      label="Host"
                      disabled
                    />
                  </template>
                  <div
                    v-for="field in visitorLogItem.fields"
                    :key="field.id"
                  >
                    <template v-if="field.type === 'text_field'">
                      <v-text-field
                        :id="field.id"
                        v-model="field.value"
                        :label="field.label"
                        :required="field.required"
                        :type="field.input_type"
                        :disabled="profile.role === 'admin'"
                      />
                    </template>
                    <template v-if="field.type === 'single_choice'">
                      <p style="margin-bottom:0">
                        {{ field.label }}
                        <span
                          v-if="field.required"
                          style="color: red"
                        >
                          *
                        </span>
                      </p>
                      <v-radio-group
                        :id="field.id"
                        v-model="field.value"
                        style="margin-top:0"
                      >
                        <div
                          v-for="option in field.options"
                          :key="option.value"
                        >
                          <v-radio
                            :label="option.value"
                            :value="option.value"
                            color="primary"
                            :disabled="profile.role === 'admin'"
                          />
                        </div>
                      </v-radio-group>
                    </template>
                    <template v-if="field.type === 'multi_choice'">
                      <p style="margin-bottom:0">
                        {{ field.label }}
                        <span
                          v-if="field.required"
                          style="color: red"
                        >
                          *
                        </span>
                      </p>
                      <v-radio-group
                        :id="field.id"
                        style="margin-top:0"
                      >
                        <checkbox-group
                          v-model="field.value"
                          :options="field.options"
                        />
                      </v-radio-group>
                    </template>
                    <template v-if="field.type === 'dropdown'">
                      <v-select
                        :id="field.id"
                        v-model="field.value"
                        :items="field.options"
                        :label="field.label"
                        item-text="value"
                        :disabled="profile.role === 'admin'"
                      />
                    </template>
                  </div>
                </v-form>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="0"
          bottom
        >
          {{ snackbarMessage }}
          <v-btn
            flat
            @click.native="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import { database } from '@/firebase';
import * as moment from 'moment';
import md5 from 'md5';
import Avatar from '@/components/common/Avatar';
import checkboxGroup from '@/components/common/CheckboxGroup';
import PhoneField from '@/components/common/PhoneField';

export default {
  name: 'VisitorLogDetails',
  components: {
    avatar: Avatar,
    'checkbox-group': checkboxGroup,
    'phone-field': PhoneField
  },
  props: {
    vlid: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      visitorLogItem: {},
      componentLoading: true,
      scrolled: false,
      offsetTop: 0,
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    fileName() {
      return md5(this.visitorLogItem.phone);
    },
    profile() {
      return _get(this.$store.state, 'profile');
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (!val) return;
        this.fetchLogItem();
      },
      immediate: true
    },
    offsetTop: {
      handler(val) {
        if (val > 20) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },

    fetchLogItem() {
      let path;
      path =
        this.profile.role === 'admin'
          ? `vms/${this.locationId}/tenants_data/${
              this.profile.cid
            }/visitor_log/${this.vlid}`
          : `vms/${this.locationId}/visitor_log/${this.vlid}`;
      database.ref(path).once('value', logItemSnapshot => {
        if (logItemSnapshot) {
          const logItem = logItemSnapshot.val();
          this.visitorLogItem = logItem;
          this.componentLoading = false;
        }
      });
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    navigateBack() {
      this.$router.back();
    },
    updatedUrl(val) {
      this.visitorLogItem.photoUri = val;
    },

    saveVisitor() {
      const nameField = this.$el.querySelector('#full_name');
      const emailField = this.$el.querySelector('#email');
      const companyField = this.$el.querySelector('#company');

      if (this.$refs.form.validate()) {
        const { fields } = this.visitorLogItem;

        const fullName = nameField.value;
        const email = emailField.value;
        const company = companyField.value;

        this.visitorLogItem.name = fullName.trim();
        this.visitorLogItem.email = email.trim() || null;
        this.visitorLogItem.company = company || null;
        this.visitorLogItem.fields = fields || null;

        this.visitorLogItem.photoUri = this.visitorLogItem.photoUri
          ? this.visitorLogItem.photoUri
          : null;
        const visitorLogItem = _cloneDeep(this.visitorLogItem);
        const path = `vms/${this.locationId}/visitor_log/${this.vlid}`;
        database
          .ref(path)
          .set(visitorLogItem)
          .catch(error => {
            this.snackbarMessage = error;
            this.snackbarColor = 'error';
            this.snackbar = true;
          });
        this.navigateBack();
      }
    },

    dashedString(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },

    toDate(millis) {
      if (millis) {
        return moment(millis).format('DD MMM YYYY h:mm A');
      }
      return '';
    }
  }
};
</script>
<style>
#visitorLogDetails {
  height: calc(100vh - var(--toolbar-height));
}
#visitorLogDetails .form {
  height: calc(100vh - var(--form-height));
  overflow-y: scroll;
}
</style>

